export default __webpack_public_path__ + "static/banner-three-shape8-ed192089d69014180745eaa8fc04e86b.png";